<template>
  <div>
    <Navigation nameColor="rgba(51, 51, 51, 1)"/>
    <div class="ai_bg_box">
      <div class="nav_box">
        <div class="null_box"></div>

        <p class="ai_title_new" style="margin-top: 20px;margin-bottom: 20px">“AI数字人”智能生成专家</p>
        <!--        <el-tabs style="margin: 2rem 0;" v-loading.fullscreen.lock="fullscreenLoading" v-model="activeName"-->
        <!--                 @tab-click="handleClick">-->
        <!--          <el-tab-pane :label="item" v-for="(item, index) in navList" :key="index"></el-tab-pane>-->
        <!--        </el-tabs>-->
        <!-- 二级菜单 -->
        <!-- 全部 -->
        <ul class="flex list" v-show="tabShow == '全部'">
          <li class="flex" @click="routePush(item)" v-for="(item, index) in menuAll" :key="index">
            <img :src="item.imgUrl" alt="">
            {{ item.title }}
            <!-- <span id="free" v-show="item.free != ''"></span> -->
          </li>
        </ul>
        <!-- AI绘画 -->
        <!--        <ul class="flex list" v-show="tabShow == 'AI绘画'">-->
        <!--          <li class="flex" @click="routePush(item)" v-for="(item, index) in menu6" :key="index">-->
        <!--            <img :src="item.imgUrl" alt="">-->
        <!--            {{ item.title }}-->
        <!--            &lt;!&ndash; <p></p> &ndash;&gt;-->
        <!--          </li>-->
        <!--        </ul>-->
        <!--        AI图画-->
        <ul class="flex list" v-show="tabShow == 'AI数字人'">
          <li class="flex" @click="routePush(item)" v-for="(item, index) in menu7" :key="index">
            <img :src="item.imgUrl" alt="">
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>
    <footerBot/>
  </div>
</template>

<script>
export default {
  mounted() {
    this.menuAll.forEach(item => {
      let item_id = item.id
      // if (item_id == 13 || item_id == 15 || item_id == 16 || item_id == 22 || item_id == 23 || item_id == 24) {
      //   this.menu6.push(item)
      // }
      if (item_id == 25 || item_id == 26 || item_id == 27 || item_id == 28 || item_id == 29 || item_id == 30) {
        this.menu7.push(item)
      }
    })
    // console.log('输出当前vuex',this.$store.state.nav_show)
  },
  data() {
    return {
      // navList: [
      //   '全部',
      //   'AI绘画',
      //   'AI数字人'
      // ],
      menuAll: [
        // {
        //   id: 13,
        //   imgUrl: require('@/assets/ai/13.png'),
        //   title: 'AI绘画',
        //   path: '/paint'
        // },
        // {
        //   id: 15,
        //   imgUrl: require('@/assets/ai/15.png'),
        //   title: '黑白图像上色',
        //   path: '/blackWhite',
        // },
        // {
        //   id: 16,
        //   imgUrl: require('@/assets/ai/16.png'),
        //   title: '图片风格转换',
        //   path: '/transImg'
        // },
        // {
        //   id: 17,
        //   imgUrl: require('@/assets/ai/17.png'),
        //   title: '人物头像动漫化',
        // },
        // {
        //   id: 22,
        //   imgUrl: require('@/assets/ai/22.png'),
        //   title: '图片背景生成',
        //   path: '/image_matting'
        // },
        // {
        //   id: 23,
        //   imgUrl: require('@/assets/ai/23.png'),
        //   title: '一键抠图',
        //   path: '/change_back'
        // },
        // {
        //   id: 24,
        //   imgUrl: require('@/assets/ai/24.png'),
        //   title: 'AI视频',
        // },
        // {
        //   id: 18,
        //   imgUrl: require('@/assets/ai/18.png'),
        //   title: '律师函',
        //   path: '/lawyer'
        // },
        // // {
        // //   id: 19,
        // //   imgUrl: require('@/assets/ai/19.png'),
        // //   title: '合同审查',
        // // },
        // {
        //   id: 20,
        //   imgUrl: require('@/assets/ai/20.png'),
        //   title: '版权侵权告知书',
        //   path: '/tort'
        // },
        // {
        //   id: 21,
        //   imgUrl: require('@/assets/ai/21.png'),
        //   title: '起诉书',
        //   path: '/prosecute',
        // },
        // {
        //   id: 24,
        //   imgUrl: require('@/assets/ai/24.png'),
        //   title: 'AI智能海报',
        //   path: '/placard',
        // },
        {
          id: 25,
          imgUrl: require('@/assets/ai/30.png'),
          title: '智能3D数字人',
          path: '/digitalHuman_3d',
        },
        {
          id: 26,
          imgUrl: require('@/assets/ai/31.png'),
          title: '智能2D数字人',
          path: '/digitalHuman_2d',
        },
        // {
        //   id: 27,
        //   imgUrl: require('@/assets/ai/32.png'),
        //   title: '定制声音克隆',
        //   path: '/digitalHuman_customizeSound',
        // },
        // {
        //   id: 28,
        //   imgUrl: require('@/assets/ai/33.png'),
        //   title: '定制照片',
        //   path: '/digitalHuman_customizePhotos',
        // },
        // {
        //   id: 29,
        //   imgUrl: require('@/assets/ai/34.png'),
        //   title: '2D数字人形象定制',
        //   path: '/digitalHuman_imageCustomization',
        // },
        {
          id: 30,
          imgUrl: require('@/assets/ai/35.png'),
          title: '智能2D精品数字人',
          path: '/digitalHuman_2d_boutique',
        }
      ],
      activeName: '0',
      // menu6: [],
      menu7: [],
      tabShow: '全部',
      fullscreenLoading: false,//加载
    }
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab)
      // console.log(this.activeName)
      this.tabShow = tab._props.label
      this.fullscreenLoading = false;
    },
    routePush(item) {
      this.$router.push(item.path)
    }
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/wordOp';
</style>